import React from 'react'
import { change, reduxForm, Form, Field, formValueSelector } from 'redux-form'
import { connect } from 'react-redux'

import { makeStyles } from '@material-ui/core/styles'
import AsyncSelect from '../shared/AsyncSelect'
import Button from '../button/Button'
import { showAlertMessage } from '../../store/alert/actions'
import cloneItemSVG from '../../assets/icons/clone-img.svg'
import {
  clearClonedTheme,
  cloneTheme,
  editTheme
} from '../../store/themes/actions'

const useStyles = makeStyles(theme => ({
  btnStyle: {
    display: 'flex',
    gap: 12,
    alignSelf: 'center',
    justifyContent: 'center',
    marginBottom: '20px',
    '& button': {
      height: 40,
      marginTop: '20px',
      minWidth: 150
    }
  },
  createBtn: {
    backgroundColor: '#386093',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#386093'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  closeBtn: {
    backgroundColor: '#EF7C8F',
    height: 44,
    padding: '14px 48px',
    gap: 10,
    borderRadius: 8,
    '&:hover': {
      backgroundColor: '#EF7C8F'
    },
    fontSize: '16px',
    fontWeight: 600,
    textTransform: 'capitalize',
    lineHeight: '19.5px'
  },
  titleTheme: {
    margin: 0,
    fontSize: '25px'
  },
  containerImg: {
    marginTop: '15px',
    width: '100%',
    height: '100%'
  },
  descriptionModule: {
    margin: '0px 0px 6px 0px'
  }
}))

const CloneThemeModuleForm = ({
  handleSubmit,
  submitting,
  pristine,
  change,
  touch,
  schoolId,
  clearClonedTheme,
  editTheme,
  themeTitle,
  closeModal,
  themeId,
  clonedTheme,
  moduleSelected
}) => {
  const classes = useStyles()
  const handleChange = event => {
    const module = event ? Number(event.value) : event
    change('theme_module_id', module)
  }

  return (
    <Form onSubmit={handleSubmit}>
      <div>
        <h2 className={classes.titleTheme}>
          Clonar tema versar: &quot;{themeTitle}&quot;?
        </h2>
        <div className={classes.containerImg}>
          <img style={{ width: '100%', height: '100%' }} src={cloneItemSVG} />
        </div>
        <h3 className={classes.descriptionModule}>
          Selecione o módulo que será associado ao tema clonado.
        </h3>
        <Field
          component={AsyncSelect}
          id='theme_module_id'
          name='theme_module_id'
          placeholder='Selecione o Título do Módulo'
          handleAsyncChange={handleChange}
          changeField={change}
          searchParam='q[title_cont]'
          touch={touch}
          maxMenuHeight={105}
          request={{
            path: 'theme_module',
            params: {
              'q[school_id_eq]': schoolId
            }
          }}
        />
      </div>
      <div className={classes.btnStyle}>
        <Button className={classes.closeBtn} type='button' onClick={closeModal}>
          Fechar
        </Button>
        <Button
          className={classes.createBtn}
          type='submit'
          disabled={!moduleSelected || submitting}
        >
          Salvar
        </Button>
      </div>
    </Form>
  )
}

const mapStateToProps = (state, props) => {
  const selector = formValueSelector('ClonethemeModuleForm')
  return {
    themes: state?.themes?.themes,
    clonedTheme: state?.themes?.clonedTheme,
    moduleSelected: selector(state, 'theme_module_id')
  }
}

const mapDispatchToProps = dispatch => ({
  change: (field, data) =>
    dispatch(change('ClonethemeModuleForm', field, data)),
  cloneTheme: params => dispatch(cloneTheme(params)),
  editTheme: params => dispatch(editTheme(params)),
  clearClonedTheme: params => dispatch(clearClonedTheme(params)),
  alert: (message, type) =>
    dispatch(
      showAlertMessage({
        message: message,
        severity: type
      })
    )
})

export default connect(mapStateToProps, mapDispatchToProps)(
  reduxForm({
    form: 'ClonethemeModuleForm',
    ouchOnChange: true,
    touchOnBlur: true,
    onSubmit: async (values, dispatch, props) => {
      const { themeId, schoolId } = props
      await dispatch(
        cloneTheme({
          theme_id: themeId,
          school_id: schoolId,
          callback: clonedTheme => {
            dispatch(
              editTheme({
                id: clonedTheme.id,
                data: { theme_module_id: values.theme_module_id }
              })
            )
            dispatch(clearClonedTheme())
          }
        })
      )
    }
  })(CloneThemeModuleForm)
)
